import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from '../../components/v3/TestimonialSlider/TestimonialSlider';
import TruestedSection from '../../components/v4/TrustedSection/TruestedSection';
import LottieIcon from '../../components/v4/LottieIcon';

//animation
import aiChatbotAnimation from "../../animations/v3/aiFeatures/aiChatbotAnimation.json";

//images
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import detailImg2 from "../../images/v4/aiSalesCrm/images/detailImg2.webp";

// import aiIcon from "../../images/v4/aiFeatures/aiChatbot/icons/aiIcon.svg";
import aiIcon from "../../images/v4/aiFeatures/aiChatbot/images/aiIcon.png";

import heroSectionBg from "../../images/v4/aiFeatures/aiChatbot/images/heroSectionBg.png";
import tabsSectionBg from "../../images/v4/aiFeatures/aiChatbot/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import benefitSectionBg from "../../images/v4/aiFeatures/aiChatbot/images/benefitSectionBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";


import experienceImg1 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg1.webp";
import experienceImg2 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg2.webp";
import experienceImg3 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg3.webp";
import experienceImg4 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg4.webp";
import experienceImg5 from "../../images/v4/aiFeatures/aiChatbot/images/experienceImg5.webp";

import realWorldImg1 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg4.webp";
import realWorldImg5 from "../../images/v4/aiFeatures/aiChatbot/images/realWorldImg5.webp";

import benefitIcon1 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/aiFeatures/aiChatbot/icons/benefitIcon6.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import growingIcon1 from "../../images/v4/aiFeatures/aiChatbot/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/aiFeatures/aiChatbot/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/aiFeatures/aiChatbot/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/aiFeatures/aiChatbot/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/aiFeatures/aiChatbot/icons/growingIcon5.svg";

import bentoSectionImg1 from "../../images/v4/aiFeatures/aiChatbot/images/bentoSectionImg1.webp";
import bentoSectionImg2 from "../../images/v4/aiFeatures/aiChatbot/images/bentoSectionImg2.webp";
import bentoSectionImg3 from "../../images/v4/aiFeatures/aiChatbot/images/bentoSectionImg3.webp";


const useStyles = makeStyles((theme) => ({
    heroSection: {
        paddingTop: '120px',
        paddingBottom: '100px',
        backgroundImage: `url(${heroSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            paddingTop: '0',
            paddingBottom: '0'
        }
    },
    heroSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: '24px',
        textAlign: 'center',
        "& span": {
            background:
                "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: 'inline-flex',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            gap: '5px',
            "@media only screen and (max-width: 600px)": {
                "& img": {
                    height: '30px',
                    width: '30px'
                }
            }
        },

    },
    detailSection: {
        background: "linear-gradient(180deg, #210538 0%, #104F4F 100%)",
    },
    detailCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column-reverse",
            gap: "40px",
        },
    },
    detailCardLeft: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "38%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "&.card2": {
                width: "100%",
            },
        },
    },
    detailCardRight: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "20px",
        width: "48%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    experienceContainer: {
        position: "relative",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        "& .centerContainer": {
            width: "70%",
            margin: "0 auto",
            textAlign: "center",
            "@media only screen and (max-width: 1024px)": {
                width: "80%",
            },
            "@media only screen and (max-width: 768px)": {
                width: "90%",
            },
            "@media only screen and (max-width: 600px)": {
                width: "100%",
            },
        },
    },
    experienceInnerContainer: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        width: "100%",
        marginTop: "20px",
        gap: "40px",
        "@media only screen and (max-width: 1024px)": {
            gap: "30px",
        },
        "@media only screen and (max-width: 768px)": {
            flexDirection: "column",
            gap: "40px",
            alignItems: "center",
            marginTop: "0",
        },
        "@media only screen and (max-width: 600px)": {
            flexDirection: "column",
            gap: "20px",
            alignItems: "flex-start",
        },
        "@media only screen and (max-width: 480px)": {
            gap: "15px",
        },
    },
    experienceContainerLeft: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "16px",
        "& .exp-desc": {
            marginBottom: "24px",
        },
        "& .view-more-link": {
            textDecoration: "underline",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            color: "#1D6FB6",
            gap: "10px",
            "@media only screen and (max-width: 768px)": {
                marginBottom: "15px",
            },
            "& img": {
                display: "inline-block!important",
                width: "16px!important",
                height: "16px",
                marginTop: "3px!important",
                transition: "transform 0.5s ease",
            },
            "&:hover": {
                color: "#010F1D",
                "& img": {
                    transform: "translateX(5px)",
                },
            },
        },
        "@media only screen and (max-width: 1024px)": {
            width: "50%",
            gap: "20px",
        },
        "@media only screen and (max-width: 768px)": {
            width: "100%",
            gap: "24px",
            alignItems: "center",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            marginTop: "0",
            alignItems: "flex-start",
            textAlign: "left",
        },
        "@media only screen and (max-width: 480px)": {
            gap: "18px",
        },
    },
    experienceContainerRight: {
        width: "60%",
        minHeight: "450px",
        "& img": {
            width: "100%",
            height: "100%",
        },
        "@media only screen and (max-width: 768px)": {
            display: "none",
        },
    },
    experienceHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        "&.noClick": {
            cursor: "not-allowed",
        },
        "& h3": {
            margin: "0",
        },
    },
    faqBoxAccordian: {
        padding: "24px",
        backgroundColor: "#f8fcff",
        borderRadius: "16px",
        cursor: "pointer",
        "&.active": {
            backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
        },
        "@media(max-width:768px)": {
            padding: "16px",
        },
    },
    body: {
        textAlign: "left",
        "& img": {
            display: "none",
        },
        "@media only screen and (max-width: 1024px)": {
            margin: "8px 0 0",
        },
        "@media only screen and (max-width: 768px)": {
            margin: "6px 0 0",
            "& img": {
                display: "block",
                width: "100%",
                marginTop: "12px",
            },
        },
        "@media only screen and (max-width: 600px)": {
            "& img": {
                display: "block",
                width: "100%",
                marginTop: "15px",
            },
        },
        "@media only screen and (max-width: 480px)": {
            margin: "5px 0 0",
            "& img": {
                marginTop: "10px",
            },
        },
        "& .exp-desc": {
            margin: "10px 0",
        },
    },
    accordianTabs: {
        backgroundImage: `url(${accordianTabsBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "& .headercenterContainer": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            textAlign: 'center',
            gap: "30px",
            "& h2": {
                width: "100%",
            },
            "& p": {
                width: "100%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
    },
    absoulteCard: {
        position: "absolute",
        margin: "0 auto",
        width: "100%",
        top: "-20%",
        "@media only screen and (max-width: 600px)": {
            top: "-16%",
        },
    },
    tabsSection: {
        backgroundImage: `url(${tabsSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "300px",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "& $supportBox": {
            position: "absolute",
            top: "-530px",
            "@media only screen and (max-width: 600px)": {
                top: "-800px",
                marginTop: 0,
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingTop: "120px",
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    tabsContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        border: "2px solid #DBDBDB",
        borderRadius: "40px",
        background: "#fff",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "10px",
            padding: "5px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    },
    tab: {
        width: "33%",
        background: "",
        padding: "18px",
        background: "transparent",
        borderRadius: "40px",
        background: "transparent",
        transition: "0.3s ease",
        cursor: "pointer",
        "&.active": {
            color: "white",
            background:
                "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: "max-content",
            padding: "10px 15px",
        },
    },
    tabCard: {
        marginTop: "65px",
        gap: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            marginTop: "30px",
            flexDirection: "column",
        },
    },
    tabCardLeftContainer: {
        width: "50%",
        display: "flex",
        gap: "40px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            gap: "20px",
            width: "100%",
        },
    },
    tabCardRightContainer: {
        width: "50%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    tabListContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
        marginTop: "50px",
        "@media only screen and (max-width: 600px)": {
            gap: "15px",
            marginTop: "20px",
        },
    },
    tabListItem: {
        display: "flex",
        width: "100%",
        margin: "0 auto",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "15px",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "15px",
            alignItems: "flex-start",
        },
    },
    tabListItemContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    wpFaq: {
        // paddingTop: "120px",
        "@media only screen and (max-width: 600px)": {
            "& section": {
                padding: "0px 0 0 !important",
            },
        },
    },
    commonPageFooterSection: {
        background:
            " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    benefitSection: {
        backgroundImage: `url(${benefitSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "260px",
        "& .centerContainer": {
            width: "100%",
            textAlign: "left",
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "flex-start",
            margin: "0 auto",
            gap: "30px",
            "& h2": {
                width: "50%",
            },
            "& p": {
                width: "40%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
        "& .trustedHeading": {
            width: "80%",
            textAlign: "center",
            margin: "0 auto",
            "@media only screen and (max-width: 600px)": {
                width: "100%",
            },
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "210px",
        },
    },
    benefitContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "24px",
        rowGap: "24px",
        marginTop: "60px",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "32px",
        },
    },
    benefitBox: {
        display: "flex",
        background: "linear-gradient(292deg, rgba(15, 56, 91, 0.40) 0%, rgba(47, 140, 218, 0.40) 100%)",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "24px",
        width: "32%",
        padding: "24px",
        borderRadius: "16px",
        transition: "0.3s ease",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "12px",
            padding: "16px",
        },
        // "&:hover": {
        //   transition: "0.3s ease",
        //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
        //   "@media only screen and (max-width: 600px)": {
        //     "&:hover": {
        //       background: "transparent",
        //     },
        //   },
        // },
    },
    partnerSlide: {
        width: "144px !important",
        "& img": {
            width: "144px",
            filter: "brightness(0)",
        },
        "@media only screen and (max-width: 600px)": {
            width: "max-content !important",
            "& img": {
                width: "100px",
            },
        },
    },
    partnerSlider: {
        padding: "10px 0 60px !important",
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "40px !important",
        },
    },
    growingBusiness: {
        backgroundImage: `url(${growingBusinessBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "80px",
        position: "relative",
        "& .header": {
            width: "55%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
            gap: "32px",
        },
        "& $featureContainer": {
            gap: "20px",
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "50px",
            "& .header": {
                width: "100%",
            },
        },
    },
    broadcastContainerInner: {
        gap: "30px",
        width: "100%",
        display: "flex",
        padding: "0 16rem 0rem 16rem",
        paddingTop: "10px  !important",
        paddingBottom: "10px  !important",
        alignItems: "stretch",
        justifyContent: "flex-start",
        "& swiper-wrapper": {
            alignItems: "stretch !important",
        },

        "& $featureContainer": {
            width: "31%",
            height: "auto  !important",
        },
        "@media only screen and (max-width: 600px)": {
            padding: "0 15px !important",
            paddingBottom: "10px !important",
        },
        "@media only screen and (min-width: 1900px)": {
            paddingLeft: "23rem !important",
            paddingRight: "23rem !important",
        },
    },
    featureContainer: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "32%",
        gap: "22px",
        boxShadow: "0px 0px 16px #C1D7DB66",
        borderRadius: "16px",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        "& p": {
            width: "90%",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "& p": {
                width: "100%",
            },
        },
    },
    bentoRow: {
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        width: '100%',
        gap: '25px',
        marginBottom: '25px',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '24px',
        width: '60%',
        padding: '40px',
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'relative',
        zIndex: '0',
        "&.purpleCard": {
            background: "#41086E",
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
                    borderRadius: "50%",
                    filter: "blur(200px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.blueCard": {
            background: "rgba(0, 154, 153, 0.4)",
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "@media only screen and (max-width: 600px)": {
            width: '100%',
            padding: '20px',
        }
    },
    bentoImg: {
        display: 'flex',
        width: '38%',
        position: 'relative',
        overflow: 'hidden',
        zIndex: '0',
        padding: '40px',
        paddingBottom: '0',
        borderRadius: '16px',
        "& img": {
            width: '100%'
        },
        "&.purpleCard": {
            background: "#41086E",
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
                    borderRadius: "50%",
                    filter: "blur(200px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.blueCard": {
            background: "rgba(0, 154, 153, 0.4)",
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "@media only screen and (max-width: 600px)": {
            width: '100%',
            padding: '20px',
            paddingBottom: '0'
        }
    },
    trustedSection: {
        "& .trustedHeading": {
            textAlign: 'center'
        }
    }
}));

const AiChatbot = () => {

    // desclaration
    const classes = useStyles();
    const [activeAccordian, setActiveAccordian] = useState(0);
    const [activeRealWorld, setActiveRealWorld] = useState(0);

    const { ref, inView } = useInView({
        threshold: 0.5, // adjust as needed
        triggerOnce: false,
    });

    // glass-effect-code
    useEffect(() => {
        // Select all cards that should have the effect
        const cardsToAnimate = [

            ...document.querySelectorAll(`.${classes.bentoContainer}.purpleCard`), // Add regularCards
            ...document.querySelectorAll(`.${classes.bentoImg}.purpleCard`), // Add regularCards
            ...document.querySelectorAll(`.${classes.bentoContainer}.blueCard`),
            ...document.querySelectorAll(`.${classes.bentoImg}.blueCard`),
        ];

        cardsToAnimate.forEach((card) => {
            if (!card) return;

            card.classList.add("glass-effect");

            // Set initial top-right position for the glass effect
            const setInitialPosition = () => {
                const rect = card.getBoundingClientRect();
                const topRightX = rect.width - 150; // Adjust this value to position from right edge
                const topRightY = 0; // Top position

                card.style.setProperty("--before-left", `${topRightX}px`);
                card.style.setProperty("--before-top", `${topRightY}px`);
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Call it initially
            setInitialPosition();

            let lastX = null;
            let lastY = null;

            const handleMouseMove = (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                lastX = x;
                lastY = y;

                card.style.setProperty("--before-left", `${x - 75}px`);
                card.style.setProperty("--before-top", `${y - 75}px`);
            };

            const handleMouseEnter = () => {
                if (lastX !== null && lastY !== null) {
                    card.style.setProperty("--before-left", `${lastX - 75}px`);
                    card.style.setProperty("--before-top", `${lastY - 75}px`);
                }
                card.style.setProperty("--before-opacity", "0.8");
            };

            const handleMouseLeave = () => {
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Store handlers on the card element for cleanup
            card.handlers = {
                mousemove: handleMouseMove,
                mouseenter: handleMouseEnter,
                mouseleave: handleMouseLeave,
                resize: setInitialPosition,
            };

            // Add event listeners
            card.addEventListener("mousemove", handleMouseMove);
            card.addEventListener("mouseenter", handleMouseEnter);
            card.addEventListener("mouseleave", handleMouseLeave);
            window.addEventListener("resize", setInitialPosition);
        });

        // Cleanup
        return () => {
            cardsToAnimate.forEach((card) => {
                if (!card) return;

                const handlers = card.handlers;
                if (handlers) {
                    card.removeEventListener("mousemove", handlers.mousemove);
                    card.removeEventListener("mouseenter", handlers.mouseenter);
                    card.removeEventListener("mouseleave", handlers.mouseleave);
                    window.removeEventListener("resize", handlers.resize);
                }
            });
        };
    }, [classes]);
    // glass-effect-code

    // data
    const experienceList = [
        {
            title: "24/7 multi-channel support",
            alt: "Conversational AI chatbot for sales",
            img: experienceImg1,
            desc: "Be available on WhatsApp, Facebook, Instagram, Telegram, and more. Never miss a customer, no matter where they reach out.",
        },
        {
            title: "Tailored conversations",
            alt: "AI chatbot managing customer chats",
            img: experienceImg2,
            desc: "Build custom topics and flows so customers get exactly the help they need. Personalise every interaction for maximum engagement.",
        },
        {
            title: "Deep CRM integration",
            alt: "AI chatbot integrated with CRM",
            img: experienceImg3,
            desc: "Every interaction is captured in Pepper Cloud, so your data stays centralised and actionable. Always have a 360° view of your customers.",
        },
        {
            title: "Seamless handoff to agents",
            alt: "Conversational AI chatbot for sales",
            img: experienceImg4,
            desc: "Transfers chats to the right team member when human expertise is needed, ensuring smooth and satisfying customer experiences.",
        },
        {
            title: "Quick to launch and scale",
            alt: "AI chatbot managing customer chats",
            img: experienceImg5,
            desc: "Set up your AI chatbot in minutes and expand effortlessly as your business grows. No coding or technical hurdles required.",
        },
    ];

    const tabContentData = [
        {
            tabContent: [
                {
                    title: "Smart lead qualification",
                    content:
                        "Ask targeted questions in real time to identify and focus on serious buyers.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Instant product details",
                    content:
                        "Share pricing, brochures, and vital product information right inside the chat.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Meeting scheduling",
                    content:
                        "Let prospects book demos and appointments automatically from conversations.",
                    alt: "AI CRM for Sales Teams",
                },
                {
                    title: "Pipeline updates",
                    content:
                        "Always know each deal's status and next steps to close faster.",
                    alt: "AI CRM for Sales Teams",
                },
            ],
            img: realWorldImg1,
            alt: "AI CRM for Sales Teams",
            subtitle:
                "Accelerate deal cycles and capture high-quality leads effortlessly.",
        },
        {
            tabContent: [
                {
                    title: "24/7 query handling",
                    content:
                        "Answer common questions instantly, even outside usual business hours.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Ticket creation",
                    content:
                        "Turn support chats into tracked issues automatically—no manual entry required.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Context-rich handoffs",
                    content:
                        "Ensure smooth service by giving agents access to full conversation history.",
                    alt: "AI CRM for Support Teams",
                },
                {
                    title: "Automated reminders",
                    content:
                        "Never miss important follow-ups or escalations with AI-driven alerts.",
                    alt: "AI CRM for Support Teams",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Support Teams",
            subtitle: "Deliver consistent, always-on assistance with fewer manual tasks.",
        },
        {
            tabContent: [
                {
                    title: "Data capture",
                    content:
                        "Collect preferences, interests, and key details from casual conversations.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Campaign follow-ups",
                    content:
                        "Auto-create tasks or reminders from hot campaign inquiries.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Personalised greetings",
                    content:
                        "Tailor your message based on visitor interests, driving better engagement.",
                    alt: "AI CRM for Marketing Teams",
                },
                {
                    title: "Trend spotting",
                    content:
                        "Identify FAQs and popular topics to refine future campaigns.",
                    alt: "AI CRM for Marketing Teams",
                },
            ],
            img: realWorldImg3,
            alt: "AI CRM for Marketing Teams",
            subtitle:
                "Boost engagement and drive campaigns through conversational AI.",
        },
        {
            tabContent: [
                {
                    title: "Insight dashboards",
                    content:
                        "Spot team and customer experience patterns instantly with unified analytics.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Consistent brand voice",
                    content:
                        "Ensure every customer interaction aligns with your brand standards.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Secure roles",
                    content:
                        "Define permissions so sensitive data is always protected.",
                    alt: "AI CRM for Business Leaders",
                },
                {
                    title: "Scale easily",
                    content:
                        "Expand usage across teams without increasing management load.",
                    alt: "AI CRM for Business Leaders",
                },
            ],
            img: realWorldImg4,
            alt: "AI CRM for Business Leaders",
            subtitle: "Gain visibility and control over team performance and CX.",
        },
        {
            tabContent: [
                {
                    title: "On-the-go lead handling",
                    content:
                        "Create or update sales and support records right from your mobile device.",
                    alt: "AI CRM for Mobile & Remote Teams",
                },
                {
                    title: "Instant history access",
                    content:
                        "View notes, past chats, and records anywhere—never be out of sync.",
                    alt: "AI CRM for Mobile & Remote Teams",
                },
                {
                    title: "AI reminders",
                    content:
                        "Get intelligent follow-up alerts outside the office or while traveling.",
                    alt: "AI CRM for Mobile & Remote Teams",
                },
                {
                    title: "Consistent engagement",
                    content:
                        "Ensure every prospect and customer receives timely, professional responses.",
                    alt: "AI CRM for Mobile & Remote Teams",
                },
            ],
            img: realWorldImg5,
            alt: "AI CRM for Mobile & Remote Teams",
            subtitle:
                "Keep teams responsive and connected from anywhere with AssistAI.",
        },
    ];

    const benefits = [
        {
            title: "Automate customer journeys",
            desc: "Handle FAQs, collect inputs, and schedule follow-ups so customers move forward without unnecessary delays—everything guided by your AI chatbot.",
            icon: benefitIcon1,
        },
        {
            title: "Connect everywhere",
            desc: "Manage conversations across WhatsApp, Facebook, Instagram, and more, all through a single chatbot integrated with Pepper Cloud. No extra tools required.",
            icon: benefitIcon2,
        },
        {
            title: "Always on-brand",
            desc: "Customise topics, chatbot names, and welcome messages so every chat perfectly fits your brand’s personality and tone.",
            icon: benefitIcon3,
        },
        {
            title: "Improve team productivity",
            desc: "Let your AI chatbot instantly resolve repetitive questions so your team can focus on meaningful conversations and closing more deals.",
            icon: benefitIcon4,
        },
        {
            title: "Integrated with your CRM",
            desc: "Every chat is automatically recorded in Pepper Cloud—keeping all leads, follow-ups, and activities centralised and up-to-date.",
            icon: benefitIcon5,
        },
        {
            title: "Scales effortlessly",
            desc: "Whether your team is five or five hundred, your chatbot adapts and grows with you—without adding complexity or slowing things down.",
            icon: benefitIcon6,
        },
    ];

    const partners = [
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    ];

    const faqs = [
        {
            question: "What is the AssistAI chatbot in Pepper Cloud CRM?",
            answer:
                "It is an advanced conversational AI chatbot that automates customer interactions across channels, directly integrated with Pepper Cloud CRM. It answers questions, captures leads, and escalates to your team when needed.",
        },
        {
            question: "How does this AI chatbot help my business?",
            answer:
                "It provides 24/7 support, handles routine queries instantly, and frees your team to focus on high-value conversations, improving productivity and customer satisfaction.",
        },
        {
            question: "Can the AssistAI chatbot work on WhatsApp and Instagram?",
            answer:
                "Yes. It connects seamlessly with WhatsApp (API and Web), Instagram, Facebook, Telegram, and more, so your customers can reach you on their preferred platforms.",
        },
        {
            question: "Does it require coding or technical skills to set up?",
            answer:
                "No. You can configure topics, flows, and integrations through simple settings in your Pepper Cloud CRM. It’s designed for quick, no-code deployment.",
        },
        {
            question: "Will the AI chatbot replace my sales or support team?",
            answer:
                "Not at all. It handles repetitive questions and data capture so your team can focus on meaningful, complex issues, creating a perfect balance of automation and human touch.",
        },
        {
            question: "Is my customer data safe with the AssistAI chatbot?",
            answer:
                "Absolutely. It follows your CRM role-based permissions and encryption standards, ensuring all data stays secure and compliant.",
        },
        {
            question: "Can it automate follow-ups or send reminders?",
            answer:
                "Yes. The chatbot can trigger reminders, schedule follow-ups, and even prompt your team when it is time to reach out, reducing missed opportunities.",
        },
        {
            question: "Does the AI chatbot work on mobile devices?",
            answer:
                "Yes. You can manage conversations, view client details, and handle leads from Pepper Cloud’s mobile CRM, making it easy to stay responsive anywhere.",
        },
    ];

    const growingList = [
        {
            icon: growingIcon1,
            background: "#F9F1FF",
            heading: "Conversational ease",
            text: "Visitors get human-like replies, making support feel friendly and natural.",
        },
        {
            icon: growingIcon2,
            background: "#F4FAFF",
            heading: "Smart handoffs",
            text: "When a human is needed, the chatbot seamlessly transfers the chat to an agent.",
        },
        {
            icon: growingIcon3,
            background: "#FFF5F1",
            heading: "On-brand experience",
            text: "Personalise the bot’s name, icon, and greeting to reflect your brand.",
        },
        {
            icon: growingIcon4,
            background: "#F9F1FF",
            heading: "Role-based security",
            text: "Your data stays protected with CRM-level permissions.",
        },
        {
            icon: growingIcon5,
            background: "#FFF5E8",
            heading: "Quick to set up",
            text: "Go live without lengthy training or technical hassles.",
        },
    ];

    return (
        <main>
            <SEO
                title={
                    "Best AI chatbot for CRM | AssistAI chatbot by Pepper Cloud"
                }
                pathname={
                    "https://peppercloud.com/best-ai-crm-features/ai-chatbot-for-crm/"
                }
                keywords="Best ai chatbot, AssistAI chatbot, Best assist ai chatbot, What is ai chatbot, Conversational ai chatbot"
                description={"Discover the best AI chatbot for CRM. Automate conversations, boost productivity, and delight customers with Pepper Cloud AssistAI chatbot. Book a demo today."}
                ogData={{
                    "og:image": [
                        "/meta/og/1X1/home.png",
                        "/meta/og/1024X512/home.png",
                        "/meta/og/1200X630/home.png",
                    ],
                }}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Pepper Cloud",
                        legalName: "Pepper Cloud PTE LTD",
                        url: "https://peppercloud.com/",
                        logo: "https://peppercloud.com/icons/logo.png",
                        foundingDate: "2017",
                        address: [
                            {
                                "@type": "PostalAddress",
                                streetAddress: "#04-01/02",
                                addressLocality: "Blk 79 Ayer Rajah Crescent",
                                addressRegion: "SG",
                                postalCode: "139955",
                                addressCountry: "Singapore",
                            },
                            {
                                "@type": "PostalAddress",
                                streetAddress:
                                    "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                                addressLocality: "Bengaluru",
                                addressRegion: "KA",
                                postalCode: "560095",
                                addressCountry: "India",
                            },
                        ],
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "customer support",
                            telephone: "+6566562616",
                            email: ["sales@peppercloud.com", "support@peppercloud.com"],
                        },
                        sameAs: [
                            "https://twitter.com/peppercloudpte",
                            "https://www.linkedin.com/company/peppercloud/",
                            "https://www.facebook.com/PepperCloudPteLtd",
                            "https://www.instagram.com/pepper.cloud/",
                        ],
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: "AssistAI",
                        description:
                            "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                        thumbnailUrl: [
                            "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                        ],
                        uploadDate: "2024-12-02",
                        contentUrl:
                            "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                        publisher: {
                            "@type": "Organization",
                            name: "Pepper Cloud",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                                width: "",
                                height: "",
                            },
                        },
                        duration: "PT1M12S",
                    },
                    {
                        "@context": "https://schema.org/",
                        "@type": "FAQPage",
                        mainEntity: [
                            {
                                "@type": "Question",
                                name: "What is the AssistAI chatbot in Pepper Cloud CRM?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "It is an advanced conversational AI chatbot that automates customer interactions across channels, directly integrated with Pepper Cloud CRM. It answers questions, captures leads, and escalates to your team when needed.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How does this AI chatbot help my business?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "It provides 24/7 support, handles routine queries instantly, and frees your team to focus on high-value conversations, improving productivity and customer satisfaction.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Can the AssistAI chatbot work on WhatsApp and Instagram?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. It connects seamlessly with WhatsApp (API and Web), Instagram, Facebook, Telegram, and more, so your customers can reach you on their preferred platforms.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Does it require coding or technical skills to set up?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "No. You can configure topics, flows, and integrations through simple settings in your Pepper Cloud CRM. It’s designed for quick, no-code deployment.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Will the AI chatbot replace my sales or support team?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Not at all. It handles repetitive questions and data capture so your team can focus on meaningful, complex issues, creating a perfect balance of automation and human touch.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Is my customer data safe with the AssistAI chatbot?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Absolutely. It follows your CRM role-based permissions and encryption standards, ensuring all data stays secure and compliant.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Can it automate follow-ups or send reminders?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. The chatbot can trigger reminders, schedule follow-ups, and even prompt your team when it is time to reach out, reducing missed opportunities.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Does the AI chatbot work on mobile devices?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. You can manage conversations, view client details, and handle leads from Pepper Cloud’s mobile CRM, making it easy to stay responsive anywhere.",
                                },
                            }
                        ],
                    },
                ]}
            />
            <section className={classes.heroSection}>
                <div className='container'>
                    <div className={classes.heroSectionContainer}>
                        <motion.h1
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-semibold font-white font-64"> Best <span> <LazyImage source={aiIcon} alt={"AssistAi - Ai crm"} />AI chatbot</span> to elevate your CRM</motion.h1>
                        <motion.p initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }} className='font-white font-wix-regular font-20'>Deliver instant, intelligent customer conversations with Pepper Cloud AssistAI chatbot, the best AI chatbot designed to automate engagement, save time, and boost team productivity.</motion.p>
                        <Link to="/contact/" className="font-18 font-white font-wix-regular primaryButton">Book a free demo</Link>
                        <LottieIcon
                            autoplay
                            loop
                            animationData={aiChatbotAnimation}
                            hover={false}
                            play
                        />
                    </div>
                </div>

                 <section>
                    <div className='container'>
                        <LazyImage alt="AI chatbot integrated with CRM" source={bentoSectionImg1} style={{ marginBottom: '40px' }} height={'100%'} width={'100%'} />
                    </div>
                    <div className='container'>
                        <div className={classes.bentoRow}>
                            <div className={clsx(classes.bentoContainer, 'purpleCard')}>
                                <h3 className='font-40 font-white font-wix-semibold'>What is AI chatbot?</h3>
                                <p className='font-18 font-white font-wix-regular'>AI chatbot is a smart virtual assistant that uses artificial intelligence to simulate human-like conversations. It answers questions, guides users, captures data, and even escalates complex issues. By automating interactions across multiple channels, AI chatbots help businesses improve responsiveness, reduce manual workload, and enhance customer satisfaction around the clock.</p>
                            </div>
                            <div className={clsx(classes.bentoImg, 'purpleCard')}>
                                <img src={bentoSectionImg2} alt="AssistAI chatbot dashboard" />
                            </div>
                        </div>
                        <div className={classes.bentoRow}>
                            <div className={clsx(classes.bentoImg, 'blueCard')}>
                                <img src={bentoSectionImg3} alt="CRM AI chatbot for customer support" />
                            </div>
                            <div className={clsx(classes.bentoContainer, 'blueCard')}>
                                <h3 className='font-40 font-white font-wix-semibold'>Why your business needs an AI chatbot?</h3>
                                <p className='font-18 font-white font-wix-regular'>Without an AI virtual assistant, your team spends countless hours answering repetitive questions, jumping across platforms, and trying to keep up with demanding customers. This often leads to missed opportunities and lower satisfaction.
                                    A conversational AI chatbot like AssistAI changes everything. It engages visitors instantly, answers common questions, and routes complex issues to your team, so customers get timely support while your staff focuses on strategic work.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </section>


            <section className={classes.experienceContainer} ref={ref}>
                <section className={classes.accordianTabs}>
                    <div className="container">
                        <div className="headercenterContainer">
                            <motion.h2
                                className="font-wix-semibold font-56 text-black1"
                                initial={{ opacity: 1, y: 20 }}
                                transition={{ duration: 0.3 }}
                                whileInView={{ opacity: 1, y: 0 }}
                            >
                                Why choose the AssistAI chatbot
                            </motion.h2>
                            <p className="font-18 font-wix-regular text-black2">
                                Pepper Cloud AssistAI chatbot is more than just a script-based responder. It’s a smart, CRM-integrated assistant that works around the clock to keep your business connected.
                            </p>
                        </div>
                        <div className={classes.experienceInnerContainer}>
                            <div className={classes.experienceContainerLeft}>
                                {experienceList.map((faq, index) => (
                                    <motion.div
                                        key={index}
                                        className={clsx(
                                            classes.faqBoxAccordian,
                                            activeAccordian === index && "active",
                                            "text-color2"
                                        )}
                                        onClick={() => {
                                            if (activeAccordian !== index) {
                                                setActiveAccordian(index); // only switch if different
                                            }
                                        }}
                                    >
                                        <div
                                            className={clsx(
                                                classes.experienceHeader,
                                                activeAccordian === index && "noClick"
                                            )}
                                        >
                                            <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                                            <img
                                                alt="Arrow"
                                                className={clsx(
                                                    classes.downArrow,
                                                    activeAccordian === index && "active"
                                                )}
                                                src={downArrow}
                                            />
                                        </div>

                                        <Collapse
                                            className={classes.body}
                                            in={activeAccordian === index}
                                        >
                                            <p className="font-18 font-wix-regular color-black2 exp-desc">
                                                {faq.desc}
                                            </p>
                                            {/* <a
                                                className="font-18 font-wix-regular view-more-link"
                                                href={faq.linkUrl}
                                            >
                                                {faq.lintText}{" "}
                                                <img alt="Arrow Right" src={arrowRight} />{" "}
                                            </a> */}
                                            <motion.img
                                                alt={faq.alt}
                                                initial={{ opacity: 1, y: 20 }}
                                                src={faq.img}
                                                transition={{ duration: 0.3 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                            />
                                        </Collapse>
                                    </motion.div>
                                ))}
                            </div>
                            <div className={classes.experienceContainerRight}>
                                {experienceList.map(
                                    (experience, index) =>
                                        index === activeAccordian && (
                                            <motion.img
                                                alt={experience.alt}
                                                initial={{ opacity: 1, y: 20 }}
                                                src={experience.img}
                                                transition={{ duration: 0.3 }}
                                                whileInView={{ opacity: 1, y: 0 }}
                                            />
                                        )
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <div className={classes.absoulteCard}>
                        <TruestedSection background={true} />
                    </div> */}
                </section>
            </section>
            <section className={classes.detailSection}>
                <div className="container">
                    <div className={classes.detailCard}>
                        <div className={classes.detailCardRight}>
                            <motion.p
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-20 font-white"
                            >
                                AssistAI
                            </motion.p>
                            <motion.h2
                                initial={{ opacity: 1, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-semibold font-56 font-white"
                            >
                                One system, endless smart actions
                            </motion.h2>
                            <motion.p
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.3 }}
                                className="font-wix-regular font-18 font-white"
                            >
                                From sentiment tagging to workflow triggers, let AI handle the
                                repetitive stuff. You focus on decisions — your CRM takes care
                                of the data.
                            </motion.p>
                        </div>
                        <div className={classes.detailCardLeft}>
                            <LazyImage
                                width={"100%"}
                                source={detailImg2}
                                alt="AI CRM for marketing teams"
                            />
                        </div>

                    </div>
                </div>
            </section>
            <section className={classes.growingBusiness}>
                <div className="container">
                    <div className="header">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-black1"
                        >
                            What modern teams expect from an AI virtual assistant?

                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-18 font-black1"
                        >
                            Modern teams need more than static scripts. They expect a chatbot that simplifies support, engages naturally, and slots right into their CRM workflows.
                        </motion.p>
                    </div>
                </div>
                <Swiper
                    slidesPerView={3.3}
                    // centeredSlides={true}
                    spaceBetween={30}
                    grabCursor={true}
                    loop={false}
                    speed={5000}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    // freeMode={true}
                    className={classes.broadcastContainerInner}
                    breakpoints={{
                        // For smaller screens (mobile)
                        0: {
                            slidesPerView: 1.3,
                            slidesPerGroup: 1,
                            freeMode: true,
                            grabCursor: false,
                            allowTouchMove: true,
                            spaceBetween: 10,
                        },
                        // For larger screens (desktop)
                        768: {
                            slidesPerView: 3.3,
                            centeredSlides: false,
                            spaceBetween: 30,
                            grabCursor: true,
                        },
                    }}
                >
                    {growingList.map((feature) => (
                        <SwiperSlide
                            className={classes.featureContainer}
                        //   style={{ background: feature.background }}
                        >
                            <LazyImage
                                source={feature.icon}
                                alt={"WhatsApp CRM for customer service"}
                                className={classes.featureIcon}
                            // alt={listItem.alt}
                            />
                            <p className="font-wix-semibold font-24 color-black1">
                                {feature.heading}
                            </p>
                            <p className="font-wix-mediu font-18 color-black1">
                                {feature.text}
                            </p>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
            </section>
            <section className={classes.benefitSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Why Pepper Cloud is the best CRM with an AI chatbot
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-18 font-white"
                        >
                            Pepper Cloud AssistAI chatbot stands out because it is more than just another support bot. It combines conversational AI, assistive AI, and deep CRM integration to deliver an unparalleled experience.
                        </motion.p>
                    </div>
                    <div className={classes.benefitContainer}>
                        {benefits.map((benefit) => (
                            <div className={classes.benefitBox}>
                                <img
                                    src={benefit.icon}
                                    alt="Customer support automation tool"
                                />
                                <p className="font-wix-semibold font-20 font-white">
                                    {benefit.title}
                                </p>
                                <p className="font-wix-regular font-16 font-white">
                                    {benefit.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            <section className={classes.tabsSection}>
                <div className={classes.absoulteCard}>
                    <TruestedSection shadow={true} background={true} />
                </div>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 color-black1"
                        >
                            Applications and use cases of AssitAI chatbot
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 color-black1"
                        >
                            The AssistAI chatbot does more than answer questions. It blends conversational AI, assistive AI, and CRM insights to help every team work smarter.
                        </motion.p>
                        <div className={classes.tabsContainer}>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 0 && "active"
                                )}
                                onClick={() => setActiveRealWorld(0)}
                            >
                                Sales teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 1 && "active"
                                )}
                                onClick={() => setActiveRealWorld(1)}
                            >
                                Support teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 2 && "active"
                                )}
                                onClick={() => setActiveRealWorld(2)}
                            >
                                Marketing teams
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 3 && "active"
                                )}
                                onClick={() => setActiveRealWorld(3)}
                            >
                                Business leaders
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 4 && "active"
                                )}
                                onClick={() => setActiveRealWorld(4)}
                            >
                                Remote teams
                            </div>
                        </div>
                    </div>
                    <div className={classes.tabCard}>
                        <div className={classes.tabCardLeftContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <div>
                                            <motion.p
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="font-wix-regular font-18 font-black1"
                                            >
                                                {listItem.subtitle}
                                            </motion.p>
                                            <div className={classes.tabListContainer}>
                                                {listItem.tabContent.map((item) => (
                                                    <motion.div
                                                        initial={{ opacity: 0, x: -20 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className={classes.tabListItem}
                                                    >
                                                        <LazyImage
                                                            source={greenCheckCircle}
                                                            className={classes.tabIcon}
                                                            alt={item.alt}
                                                        />
                                                        <div className={classes.tabListItemContent}>
                                                            <p className="font-wix-semibold font-18 font-black1">
                                                                {item.title}:
                                                            </p>
                                                            <p className="font-wix-regular font-18 font-black1">
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        <div className={classes.tabCardRightContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <motion.div
                                            initial={{ opacity: 1, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        // className={classes.aiSectionRight}
                                        >
                                            <LazyImage
                                                source={listItem.img}
                                                alt={listItem.alt}
                                                width={"100%"}
                                            />
                                        </motion.div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialSlider desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."} heading={"Real stories. Real results."} noButton={true} />
            <section className={classes.trustedSection}>
                <div className='container'>
                    <div className="trustedHeading">
                        <motion.h3
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-24 font-black1"
                        >
                            Trusted by leading businesses for outstanding efficiency
                        </motion.h3>
                    </div>
                </div>
                <Swiper
                    className={classes.partnerSlider}
                    slidesPerView="auto"
                    spaceBetween={60}
                    loop={true}
                    speed={2000}
                    modules={[Autoplay]}
                    allowTouchMove={false}
                    autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                >
                    {partners.map((partner) => (
                        <SwiperSlide className={classes.partnerSlide}>
                            <img src={partner.icon} alt={partner.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
            <div className={classes.wpFaq}>
                <FaqSection
                    backgroundColor={"#FFFFFF"}
                    heading={"Frequently asked questions - AI CRM for marketing teams"}
                    faqs={faqs}
                />
            </div>
            <section className={classes.commonPageFooterSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            className="font-wix-medium font-56 font-white"
                            initial={{ opacity: 1, y: 30 }}
                            transition={{ duration: 0.5 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            Start transforming customer conversations with the best AI chatbot today
                        </motion.h2>
                        <Link
                            className="primaryButton font-20 font-wix-medium font-white"
                            to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                        >
                            Get started
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default AiChatbot